import React, { Component, Fragment } from "react";
import Header from './Header';
import Footer from './Footer';
import { injectStripe } from 'react-stripe-elements';
import { connect } from "react-redux";
import { updateFollower } from "../store/actions/auth";
import { showAlert } from '../store/actions/alert';
import { fetchReferralDetail } from '../store/actions/brand'
import Card from './../modals/card'
import { APP_LINK } from './../constants';
class Follow extends Component {

  constructor(props) {
    super(props)

    this.state = {
      email: '',
      referralCode: '',
      isUserExist: false,
      isFetchResponse: false,
      isSuccessResponse: false,
      isValidPage: true,
      isSubscribedUser: false,
      cardHolderName: '',
      isSubmit: false,
      planName: '',
      partnerImg: '',
      isReferalResponse: false
    };

    this.paymentCard = React.createRef();
  }

  componentDidMount() {
    const { match: { params: { referralCode } } } = this.props;
    this.props.fetchReferralDetail(referralCode).then((res) => {
      this.setState({
        planName: res.plan,
        partnerImg: res.partnerImg,
        isReferalResponse: true
      })
    }).catch(() => this.setState({ isValidPage: false }));
  }

  openPaymentForm = (email, referralCode, isUserExist) => {
    if (isUserExist) {
      this.setState({
        email: email,
        referralCode: referralCode,
        isUserExist: true,
        isSuccessResponse: false,
        isFetchResponse: true
      }, () => {
      });
    } else {
      this.setState({
        isFetchResponse: true,
        isUserExist: false,
        isSuccessResponse: false
      });
    }
  }

  showSuccessMessage = (isUserExist) => {
    this.setState({
      isFetchResponse: true,
      isSuccessResponse: true,
      isUserExist: isUserExist
    });
  }

  async createNonce(cardHolderName) {
    // Send the nonce to your server
    const { updateFollower } = this.props;
    const { showAlert } = this.props;
    const res = await this.props.stripe.createToken({ name: cardHolderName });
    if (res.error) {
      const message = res.error.message;
      showAlert(message, true);
      this.setState({
        isSubmit: false,
      });
    } else {
      const token = res.token;
      updateFollower({
        email: this.state.email,
        referenceCode: this.state.referralCode,
        token: token.id,
        type: 'basic',
      }).then((response) => {
        this.showSuccessMessage(this.state.isUserExist);
        this.setState({
          isSubmit: false,
        });
      }).catch((error) => {
        this.setState({
          isSubmit: false,
        });
      })
    }
  }

  handleSubmit = e => {
    e.preventDefault();
    this.paymentCard.current.getWrappedInstance().handleSubmit()
    const paymentCardInstance = this.paymentCard.current.getWrappedInstance();
    const { isCardError, cardHolderName } = paymentCardInstance.state;
    if (isCardError) {
      this.setState({
        isSubmit: true,
      });
     this.createNonce(cardHolderName);
    }
  };

  handleChange = e => {
    const name = e.target.name;
    const value = e.target.value;
    const { errors } = this.validator;
    errors.remove(name);
    this.setState({ cardHolderName: value });
    this.validator.validate(name, value).then(() => {
      this.setState({ formErrors: errors });
    });
  };

  renderPartnerImage() {
		const { partnerImg, isReferalResponse } = this.state;
  	return partnerImg !== '' ? (
			<img src={partnerImg} class = "img-responsive center-block" alt="Thumb" />
		) : 
    isReferalResponse && <img src="/assets/img/phone-brands-login.jpg" width="400px" alt="Thumb" />
	}

  render() {

    const { isSubmit, planName } = this.state;

    const borderStyle = '2px solid #e95e00';

    return (
      <Fragment>
        <Header {...this.props} />
        {this.state.isFetchResponse && this.state.isUserExist && !this.state.isSuccessResponse &&
          <div style={{ 'paddingBottom': '30px' }} id="overview" className="work-list-area default-padding">
            <div className="container">
              <div className="row">
                <div className="col-md-12 info follow-me-top text-center">
                  <p style={{ 'fontSize': '20px' }}>We see that you are indeed a Fitbanx member, but we do not have you listed as a membership subscriber.</p>
                  <p style={{ 'fontSize': '20px' }}>Please enroll as a membership subscriber by entering your credit card information below.</p>
                </div>

                <div style={{ 'marginTop': '50px', 'border': '1px solid #eee', 'padding': '50px' }} className="col-md-12">
                  <div className="row">
                    <div className="col-md-6">
                      <h3>Stop guessing how to workout. Follow me and my creative workouts in Fitbanx.</h3>
                      <ul className="scenario-list">
                        <li>14 day free trial, then only {planName}</li>
                        <li>Cancel before the end of the free trial and you won’t be billed</li>
                        <li>Access to all premium Fitbanx content with subscription</li>
                      </ul>
                    </div>
                    <div className="col-md-6">
                      <form onSubmit={this.handleSubmit} noValidate>
                        <div className="paymentCardDiv col-md-12">
                        <Card  ref={this.paymentCard}  brandIcon="brand-follow-existing-user-icon"></Card>
                          <div className="col-md-12">
                            <div className="row">
                              <div className="col-md-12">
                                <button
                                  type="submit"
                                  className="btn circle btn-light border btn-md"
                                  disabled={isSubmit}
                                >
                                  Finish
                      </button>
                              </div>
                            </div>
                          </div>

                          <div className="col-md-6"></div>

                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        }
        {this.state.isFetchResponse && !this.state.isUserExist && !this.state.isSuccessResponse &&
          <div className="banner-area auto-height text-center text-normal text-light shadow dark-hard bg-fixed scenaro-3">
            <div className="container">
              <div className="row">
                <div className="content-box">
                  <div className="col-md-10 col-md-offset-1">
                    <div className="content">
                      <p style={{ 'marginBottom': '50px' }}>
                        We do not see that you are an existing Fitbanx user.
                        Please make sure to enter the email address that you use to log in with Fitbanx if you believe that you are an existing user.
                        </p>
                      <a style={{ 'background': '#fff', 'border': borderStyle, 'color': '#e95e00' }}
                        className="btn circle btn-light border btn-md popup-youtube light video-inline"
                        data-toggle="modal" data-target="#alreadyFitbanx">I am already a Fitbanx user</a><br />
                      <a style={{ 'border': borderStyle }} className="btn circle btn-light border btn-md"
                        data-toggle="modal" data-target="#enroll">I need to enroll in Fitbanx</a>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        }
        {!this.state.isFetchResponse && !this.state.isSuccessResponse && !this.state.isFetchResponse &&
          <div style={{ 'paddingBottom': '30px' }} id="overview" className="work-list-area default-padding">
            {this.state.isValidPage ?
              <div className="container">
                <div className="row">
                  <div className="col-md-6 thumb text-center">
                     {this.renderPartnerImage()}
                  </div>
                  <div className="col-md-6 info follow-me-top text-center">
                    <h3>Follow me and my creative workouts in the Fitbanx app.</h3>
                    <a style={{ 'marginTop': '0px', 'background': '#fff', 'border': '2px solid #e95e00', 'color': '#e95e00' }}
                      className="btn circle btn-light border btn-md" data-toggle="modal" data-target="#alreadyFitbanx">
                      I am already a Fitbanx user</a>
                    <a style={{ 'marginTop': '20px', 'marginBottom': '20px' }}
                      className="btn circle btn-light border btn-md" data-toggle="modal"
                      data-target="#enroll">I need to enroll in Fitbanx</a>
                  </div>
                </div>
              </div>
              : <div className="container">
                <div className="row">
                  <div className="col-md-12 info follow-me-top text-center">
                    <h3>Not Found.</h3>
                  </div>
                  <div className="col-md-12 col-sm-12 equal-height item">
                    <div className="text-center">
                      <img style={{ 'margin': '50px auto' }} src="/assets/img/logo.png" width="300" alt="logo" />
                    </div>
                  </div>
                </div>
              </div>
            }
          </div>
        }
        {
          this.state.isFetchResponse && this.state.isSuccessResponse && this.state.isUserExist &&
          <div style={{ 'paddingBottom': '30px' }} id="overview" className="work-list-area default-padding scenaro-1">
            <div className="container">
              <div className="row">
                <div className="col-md-12 info follow-me-top text-center">
                  <p style={{ 'fontSize': '20px' }}>
                    Thank you for registering to follow me and my creative workouts inside Fitbanx!
                    Download Fitbanx and click the My Coach tab to get started now!
</p>
                </div>
                <div className="col-md-12" style={{ 
										width: '555px',
										textAlign: 'center',
										margin: '20px auto',
										float: 'none'
									 }}>
										<div className="col-md-6">
											<a href={APP_LINK.IOS} target="_blank">
												<img src="/assets/img/app-store.png" alt="app-store" />
											</a>
										</div>
										<div className="col-md-6">
											<a href={APP_LINK.ANDROID} target="_blank">   
												<img
													src="/assets/img/play-store.png"
													alt="play-store"
												/>
											</a>
										</div>
										<div className="col-md-12">
											<h5 style={{ marginTop: '20px', fontSize: '60px' }}>
												<em>Free Download</em>
											</h5>
										</div>
									</div>
                <div className="col-md-12 col-sm-12 equal-height item">
                  <div className="text-center">
                    <img style={{ 'margin': '50px auto' }} src="/assets/img/logo.png" width="300" alt="logo" />
                  </div>
                </div>
              </div>
            </div>
          </div>

        }
        {
          this.state.isFetchResponse && this.state.isSuccessResponse && !this.state.isUserExist &&
          <div style={{ 'paddingBottom': '30px' }} id="overview" className="work-list-area default-padding scenaro-1">
            <div className="container">
              <div className="row">
                <div className="col-md-12 info follow-me-top text-center">
                  <p style={{ 'fontSize': '20px' }}>
                    Thank you for registering to follow me and my creative workouts inside Fitbanx! Download Fitbanx and click the My Partner tab to get started now!
</p>
                </div>

                <div className="col-md-12" style={{ 
										width: '555px',
										textAlign: 'center',
										margin: '20px auto',
										float: 'none'
									 }}>
										<div className="col-md-6">
											<a href={APP_LINK.IOS} target="_blank">
												<img src="/assets/img/app-store.png" alt="app-store" />
											</a>
										</div>
										<div className="col-md-6">
											<a href={APP_LINK.ANDROID} target="_blank">   
												<img
													src="/assets/img/play-store.png"
													alt="play-store"
												/>
											</a>
										</div>
                  </div>
                
                <div className="col-md-12 col-sm-12 equal-height item">
                  <div className="text-center">
                    <img style={{ 'margin': '50px auto' }} src="/assets/img/logo.png" width="300" alt="logo" />
                  </div>
                </div>
              </div>
            </div>
          </div>

        }
        <Footer {...this.props} planName={planName} openPaymentForm={this.openPaymentForm} showSuccessMessage={this.showSuccessMessage} />
      </Fragment>
    )
  }
}

function mapStateToProps(state, ownProps) {
  return {
    paymentToken: state.payments.token
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    updateFollower: (data) => {
      return dispatch(updateFollower(data));
    },
    fetchReferralDetail: (referenceCode) => {
      return dispatch(fetchReferralDetail(referenceCode, true));
    },
    showAlert: (message, isError) => {
      return dispatch(showAlert(message, isError));
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(injectStripe(Follow));



// WEBPACK FOOTER //
// ./src/components/Follow.js